module.exports = __webpack_public_path__ + "videos/mts-products-chats-favorite-features.e7bc5ba.mp4";